// extracted by mini-css-extract-plugin
export default {"coevaluationItem":"CoevaluationItem_coevaluationItem__lh9LZ","textField":"CoevaluationItem_textField__M5Ibh"};